import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import { faDiscord, faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faMailBulk, faPhone } from '@fortawesome/free-solid-svg-icons';

const Footer = ({ showNavigation = false }) => {


	return (
		<>
			<footer className={`container ${!showNavigation && ''} pb-8 md:pb-16 md:pt-12 pt-8 text-slate-600 dark:text-white`}>
				<div className='grid md:grid-cols-4 mb-20 justify-between gap-y-10 md:gap-y-0 grid-cols-1 items-start text-center mt-4 md:text-start'>
					<div className='flex flex-col space-y-4'>
						<div className='dark:text-white text-career-dark-200 font-semibold text-lg mb-2'>Хувь хүн</div>
						<Link className='dark:text-white text-career-dark-400' href={'/login'}>Нэвтрэх</Link>
						<Link className='dark:text-white text-career-dark-400' href={'/register'}>Бүртгүүлэх</Link>
						<Link className='dark:text-white text-career-dark-400' href={'https://discord.gg/ZDM5TtAnmJ'}>Discord</Link>
					</div>

					<div className='flex flex-col space-y-4'>
						<div className='dark:text-white text-career-dark-200 font-semibold text-lg mb-2'>Байгууллага</div>
						<Link className='dark:text-white text-career-dark-400' href={'/collab'}>Хамтран ажиллах</Link>
					</div>


					<div className='flex flex-col space-y-4'>
						<div className='dark:text-white text-career-dark-200 font-semibold text-lg mb-2'>Грейт Айкт ХХК</div>
						<Link className='dark:text-white text-career-dark-400' href={'/about-us'}>Бидний тухай</Link>
						<Link className='dark:text-white text-career-dark-400' href={'/tos'}>Үйлчилгээний нөхцөл</Link>
						<Link className='dark:text-white text-career-dark-400' href={'/privacy'}>Нууцлалын бодлого</Link>
					</div>


					<div className='hidden md:flex md:flex-col space-y-4'>
						<Link className='w-full bg-career-green p-3 text-white text-center rounded' href={'tel:+97686186948'}><FontAwesomeIcon width={24} height={24} className='me-2' icon={faPhone}/> 8618 6948</Link>
						<Link className='w-full bg-career-teal p-3 text-white text-center rounded' href={'mailto:info@mycareer.mn'}><FontAwesomeIcon width={24} height={24} className='me-2' icon={faMailBulk}/>info@mycareer.mn</Link>
					</div>

				</div>
				<div className='flex md:hidden flex-col gap-2 mb-10'>
					<Link className='w-full bg-career-green p-3 text-white text-center rounded' href={'tel:+97686186948'}><FontAwesomeIcon width={24} height={24} className='me-2' icon={faPhone}/> 8618 6948</Link>
					<Link className='w-full bg-career-teal p-3 text-white text-center rounded' href={'mailto:info@mycareer.mn'}><FontAwesomeIcon width={24} height={24} className='me-2' icon={faMailBulk}/>info@mycareer.mn</Link>
				</div>
				
				<div className='flex flex-col md:flex-row justify-between items-center space-y-10 text-center md:text-start md:space-y-0'>
					<div>
						<Image
							src="/logo-black-vector.svg"
							alt="Logo Light Mode"
							className="dark:hidden"
							width={180}
							height={40}
							priority
						/>
						<Image
							src="/logo-white-vector.svg"
							alt="Logo Dark Mode"
							className="hidden dark:block"
							width={180}
							height={40}
							priority
						/>
					</div>
					<div className=" dark:text-white text-career-dark-400">&copy; 2024 Грейт Айкт, ХХК. Оюуны өмчөөр хамгаалагдсан.</div>
					<div className="flex space-x-5 dark:text-white text-career-dark-400">
						<Link href="https://www.facebook.com/mycareer.mn"><FontAwesomeIcon icon={faFacebook} width={24} height={24} /></Link>
						<Link href="https://discord.gg/ZDM5TtAnmJ"><FontAwesomeIcon icon={faDiscord} width={24} height={24} /></Link>
						<Link href="https://www.instagram.com/mycareer.mn/"><FontAwesomeIcon icon={faInstagram} width={24} height={24} /></Link>
					</div>
				</div>
			</footer>
		</>
	);
};

export default Footer;
